<template lang="pug">
.section-container(@click="$emit( 'click' )")
	.section(
		class="section"
		:class="sectionClass"
	)
		h4.section-title {{ courseNotRequired ? 'No Subject Selected' : section.label }}
	.selected-count
		//- h5(:class="{ more : count > 0 }") {{ countPhrase }}
		template(v-if="courses.length > 0")
			.course(v-for="course in courses") {{ course.name }}
		p.no-courses-text(v-else) 0 courses selected
</template>

<script>
export default {
  name  : 'your-plan-column-item',
  props : {
    // Refer to baseStudentPlan.js for the structure
    section : {
      type : Object,
    },
  },

  mounted() {
    // console.log( this.section );
  },

  computed : {
    count() {
      return this.section.courses ? this.section.courses.length : 0;
    },

    countPhrase() {
      return this.count === 1 ? `${this.count} course selected` : `${this.count} courses selected`;
    },

    courseNotRequired() {
      return !this.section.gradRequired && !this.section.courseRequired && !this.section.gradCredits;
    },

    courses() {
      return this.section.courses
        ? this.section.courses
          .map( id => this.$store.getters.getCourseByID( id ) )
          .filter( course => !!course )
        : [];
    },

    sectionClass() {
      return {
        'section-required'     : this.section.gradRequired,
        'unrequiredsection'    : !this.section.gradRequired && this.section.sectionRequired,
        'fade-text'            : this.courseNotRequired,
        'two-courses-required' : ['Government / Econ', 'Freshman Seminar / Health'].includes( this.section.label ),
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.section-container {
	cursor: pointer;
	background: white;
	box-shadow: 0 2px 12px rgba( 0, 0, 0, 0.15 ), 0 0 2px rgba( 0, 0, 0, 0.15 );
	border-radius: 8px;
	padding: 10px 30px;
	.section {
		width: 100%;
		.section-title {
			font-family : 'Work Sans', sans-serif;
			letter-spacing: -0.03em;
			font-weight: 500;
			font-size: 18px;
      position: relative;
		}

		.requiredsection,
		.unrequiredsection {
			color: $ypText;
		}
		&.fade-text .section-title {
			color: rgba( 79, 79, 79, 0.4 );
		}
		&.section-required .section-title {
			&::before {
				content: '*';
				color: $close;
        position: absolute;
        top: 0;
        left: -12px;
			}
		}
    &.two-courses-required .section-title {
      &::before {
        left: -19px !important;
      }
      &::after {
        content: '†';
        color: #07566F;
        position: absolute;
        top: -4px;
        left: -9px;
      }
    }
	}

	.selected-count {
		width: 100%;
		.course {
			font-family: 'Work Sans', sans-serif;
			font-weight: normal;
			letter-spacing: -0.03em;
			line-height: 95%;
			font-size: 14px;
			margin-top: 8px;
			color: #2668D0;
		}
		.no-courses-text {
			font-size: 14px;
		}
	}
}

@media print {
	@page { size: landscape; }

	.section-container {
		box-shadow: none;
		border: 1px solid rgba(0, 0, 0, 0.2);

		.section .section-title {
			font-size: 14px;
		}

		.selected-counter h5 {
			font-size: 12px;
		}
	}
}
</style>
